import React from "react";

import CallMergeIcon from "@mui/icons-material/CallMerge";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Modal, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import useDialogState from "@/hooks/useDialogState";
import { colors } from "@/theme/overrides/colors";

import SectionContainer from "./components/SectionContainer";
import Form from "./store/Form";

const useStyles = makeStyles()({
  root: {
    width: "70%",
    height: "auto",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  },
  deleteIconColor: {
    color: colors.error,
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: colors.white,
    height: "auto",
    borderRadius: "16px",
  },
  mergeIconColor: {
    color: "#FFB41E",
  },
  mergeIconModalSize: {
    height: "60px",
    width: "60px",
  },
  sectionDeletedModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionDeletedModalIconSize: {
    height: "40px",
    width: "40px",
  },
  sectionDeletedModalBody: {
    width: "250px",
    paddingBlock: "20px",
    paddingInline: "66px",
  },
  sectionMergedModalBody: {
    width: "250px",
    paddingBlock: "20px",
  },
  sectionDeletedModalTitle: {
    fontWeight: "700",
  },
});

export type SectionsAndElementsHandle = {
  addSection: () => void;
};

interface Props {
  form: Form;
}

const SectionsAndElements: React.FC<Props> = observer(({ form }) => {
  const { classes } = useStyles();

  const sectionDeletedDialog = useDialogState();
  const sectionMergedDialog = useDialogState();

  return (
    <>
      <div className={classes.root}>
        {form.sections.map((section) => (
          <SectionContainer
            key={section.key}
            section={section}
            onDelete={sectionDeletedDialog.show}
            onMergeUp={sectionMergedDialog.show}
          />
        ))}
      </div>

      <Modal
        className={classes.sectionDeletedModal}
        open={sectionDeletedDialog.shown}
        onClose={sectionDeletedDialog.hide}
      >
        <Box
          className={`${classes.modalBody} ${classes.sectionDeletedModalBody}`}
        >
          <DeleteIcon
            className={`${classes.deleteIconColor} ${classes.sectionDeletedModalIconSize}`}
          />
          <Typography
            variant="subtitle1"
            className={classes.sectionDeletedModalTitle}
          >
            Section deleted
          </Typography>
        </Box>
      </Modal>

      <Modal
        className={classes.sectionDeletedModal}
        open={sectionMergedDialog.shown}
        onClose={sectionMergedDialog.hide}
      >
        <Box
          className={`${classes.modalBody} ${classes.sectionMergedModalBody}`}
        >
          <CallMergeIcon
            className={`${classes.mergeIconColor} ${classes.mergeIconModalSize}`}
          />
          <Typography
            variant="subtitle1"
            className={classes.sectionDeletedModalTitle}
          >
            Sections merged
          </Typography>
        </Box>
      </Modal>
    </>
  );
});

export default SectionsAndElements;
